import {fileStatusChange} from "@/components/file_process_js/utils";
import {uploadFileToOSS} from "@/components/file_process_js/api";
import {ElMessage} from "element-plus";

export async function fileUploadMD(fileInfo){
    // todo 判断文件是否已经上传
    if (fileInfo.status_code > 109 || fileInfo.status_code < 0){
        return
    }
    fileStatusChange(fileInfo, "uploading")
    const response = await uploadFileToOSS(fileInfo['project_id'], fileInfo)
    if (response.res === "ok") {
        fileInfo['upload'] = true
        fileStatusChange(fileInfo, "uploaded")
    } else {
        fileStatusChange(fileInfo, "uploaded fail", -102)
        console.error("response.error", response)
        ElMessage.warning(`上传文件[${fileInfo.file_path}]出现未知错误，错误详情：[${response.error}]`)
    }

}


export function getUploadMd(fileInfo, config) {
    return fileUploadMD
}